import * as yup from 'yup';

export const campaignConfigSchema = yup.object({
  id: yup.string(),
  //Candidate selection Rules
  threshold: yup.array().of(yup.number()),
  recentCampaign: yup.number(),
  recentCampaignDuration: yup.string(),
  recentCheck: yup.boolean(),
  nonResponsiveCandidateCheck: yup.boolean(),
  nonResponsiveCandidateStatus: yup.string(),
  excludeCandidateCheck: yup.boolean(),

  //Additional Rules
  excludeCandidateEmailCheck: yup.boolean(),
  excludeCandidateEmail: yup.number(),
  excludeCandidateEmailDuration: yup.string(),
  deliverabilityCheck: yup.boolean(),
  excludeCandidatehiringCheck: yup.boolean(),
  lastSubmission: yup.number(),
  submissionDuration: yup.string(),
  submissionCheck: yup.boolean(),
  businessDefinitions: yup.array().of(yup.string()),
  validEmailCheck: yup.boolean(),

  // Sender and Campaign Controls
  senderEmail: yup.object({
    fromEmail: yup.string().email(),
    label: yup.string(),
    fromName: yup.string(),
    id: yup.string(),
    signatureText: yup.string(),
  }),
  followUpEmailCheck: yup.boolean(),
  followUpEmail: yup.number(),
  followUpEmailDuration: yup.string(),
});

export const defaulCampaignConfigValues = {
  id: '',
  //Candidate selection Rules default Values
  threshold: [90, 100],
  recentCampaign: 0,
  recentCampaignDuration: 'Days',
  recentCheck: false,
  nonResponsiveCandidateCheck: false,
  nonResponsiveCandidateStatus: 'Open',
  excludeCandidateCheck: false,

  // Additional Rules default Values
  excludeCandidateEmailCheck: false,
  excludeCandidateEmail: 0,
  excludeCandidateEmailDuration: 'Days',
  deliverabilityCheck: false,
  excludeCandidatehiringCheck: false,
  lastSubmission: 0,
  submissionDuration: 'Days',
  submissionCheck: false,
  businessDefinitions: [] as string[],
  validEmailCheck: false,

  //Sender and Campaign Controls

  senderEmail: { fromEmail: '', label: '', id: '', signatureText: '', fromName: '' },
  followUpEmailCheck: false,
  followUpEmail: 0,
  followUpEmailDuration: 'Days',
};

export type campaignConfigType = yup.InferType<typeof campaignConfigSchema>;
